import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { RatesFilterType } from '@features/rates';
import { Property } from 'shared-types/Property';

import PackagesV1 from './container';
import { RatesV2 } from '@features/rates/pages/Rates/v2';

type PackagesVersionProps = {
  property: Property;
  language: string;
  type?: RatesFilterType;
};

export const PackagesVersion: FC<PackagesVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');

  if (isV2) return <RatesV2 language={props.language} type={props.type} />;
  return <PackagesV1 {...props} />;
};
